import axios from "axios";
import { makeAutoObservable } from "mobx";
import { IUser } from "../models/IUser";
import { authResponse } from "../models/response/authResponse";
import AuthService from "../services/AuthService";
import UserService from "../services/UserService";

export default class Store {
  user = {} as IUser;
  users = [] as IUser[];
  isAuth = false;
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setAuth(bool: boolean) {
    this.isAuth = bool;
  }

  setUser(user: IUser) {
    this.user = user;
  }

  setUsers(users: IUser[]) {
    this.users = users;
  }

  setLoading(bool: boolean) {
    this.isLoading = bool;
  }

  async getUsers() {
    try {
      const response = await UserService.fetchUsers();
      this.setUsers(response.data);
      return this.users as IUser[];
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async login(email: string, password: string) {
    try {
      const response = await AuthService.login(email, password);
      localStorage.setItem("token", response.data.accessToken);
      this.setAuth(true);
      this.setUser(response.data.user);
      this.getUsers();
      return response.status;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async logout() {
    try {
      await AuthService.logout();
      localStorage.removeItem("token");
      this.setAuth(false);
      this.setUser({} as IUser);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async registration(
    email: string,
    password: string,
    phone: number,
    firstName: string,
    lastName: string,
    middleName: string,
    workPlace: string,
    diplomaNumber: string
  ) {
    try {
      await AuthService.registration(
        email,
        password,
        firstName,
        lastName,
        middleName,
        workPlace,
        diplomaNumber,
        phone
      );
      // localStorage.setItem("token", response.data.accessToken);
      // this.setAuth(true);
      // this.setUser(response.data.user);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async restoreLink(email: string) {
    try {
      await AuthService.restoreLink(email);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async updateUser(
    email: string,
    firstName: string,
    lastName: string,
    middleName: string,
    workPlace: string,
    diplomaNumber: string,
    phone: number
  ) {
    try {
      const response = await AuthService.updateUser(
        email,
        firstName,
        lastName,
        middleName,
        workPlace,
        diplomaNumber,
        phone
      );
      this.setAuth(true);
      this.setUser(response.data.user);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async updatePassword(id: string, password: string, passwordNew: string) {
    try {
      await AuthService.updatePassword(id, password, passwordNew);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async activateUser(email: string, isActivated: boolean, user: IUser) {
    try {
      await AuthService.activateUser(email, isActivated, user);
      this.getUsers();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async restorePassword(password: string, link: string) {
    try {
      await AuthService.restorePassword(password, link);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async getActivationLink() {
    try {
      await UserService.getLink();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    }
  }

  async checkAuth() {
    this.setLoading(true);
    try {
      const response = await axios.get<authResponse>(`${process.env.REACT_APP_BASE_URL}/refresh`, {
        withCredentials: true,
      });
      localStorage.setItem("token", response.data.accessToken);
      this.setAuth(true);
      this.setUser(response.data.user);
      this.getUsers();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          return error.response.data.message;
        }
      } else {
        console.log(error);
      }
    } finally {
      this.setLoading(false);
    }
  }
}
